var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.test'),"name":"monitoringTests","url":_vm.$listRoutes.monitoringTests,"table":_vm.monitoringTests,"filters":_vm.monitoringTestsFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }